import { i18n } from '@lingui/core';
import { Trans, t } from '@lingui/macro';
import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { useQuery } from '../../common/hooks/useQuery';
import { useYupValidationForm } from '../../common/hooks/useYupValidationForm';
import { DEFAULT_REDIRECT_URI } from '../../constants';
// import googleLogo from '../../img/ggLogo.svg';
import { signup } from '../../util/APIUtils';
// import { GetCurrentLanguage } from '../../util/ChangeLanguage';
import { error, success } from '../../util/toast';

const validationSchema = yup.object({
  lastName: yup
    .string()
    .trim()
    .required(`Không được để trống`)
    .max(25, `Tối đa 25 ký tự`),
  firstName: yup
    .string()
    .trim()
    .required(`Không được để trống`)
    .max(50, `Tối đa 50 ký tự`),
  login: yup
    .string()
    .trim()
    .required(`Không được để trống`)
    .max(25, `Tối đa 25 ký tự`)
    .matches(
      /^[a-zA-Z0-9]([._-](?![._-])|[a-zA-Z0-9]){0,18}[a-zA-Z0-9]$/,
      `Chỉ chấp nhận chữ thường, chữ số và các ký tự ., -, _(các ký tự phải nằm giữa chữ hoặc số)`,
    ),
  phone: yup
    .string()
    .trim()
    .required(t`Không được để trống`)
    .matches(/^(\+84|0[3|5|7|8|9])+([0-9]{8,10})$/, `Không đúng định dạng`),
  email: yup
    .string()
    .trim()
    .email(`Không đúng định dạng`)
    .required(`Không được để trống`),
  terms: yup
    .boolean()
    .isTrue(
      `Để đăng ký bạn phải chấp thuận điều khoản điều kiện của chúng tôi`,
    ),
  password: yup
    .string()
    .trim()
    .matches(
      /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,}$/,
      `Tối thiểu 8 ký tự bao gồm số, chữ hoa, chữ thường và 1 ký tự đặc biệt`,
    ),
  authPassword: yup
    .string()
    .oneOf([yup.ref('password'), null], `Mật khẩu không khớp!`),
});

const FormUserSignUp = (props) => {
  const { step, handleTempRegisterKey } = props;
  // const curLang = GetCurrentLanguage();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useYupValidationForm(validationSchema);
  const [showPass, setShowPass] = useState({ pass: false, authPass: false });
  const query = useQuery();
  const history = useHistory();
  const renderUrlTTerms = () => {
    const redirectParam = query.get('redirect');
    return redirectParam ?? DEFAULT_REDIRECT_URI + '/terms';
  };

  // const getRedirect = () => {
  //   let redirect = query.get('redirect');
  //   if (!redirect) {
  //     redirect = DEFAULT_REDIRECT_URI;
  //   }
  //   const url = new URL(redirect);
  //   const params = url.searchParams;
  //   params.set('lang', curLang);
  //   return url;
  // };

  const onSubmit = (data) => {
    data = {
      login: data.login,
      email: data.email,
      phone: data.phone,
      password: data.password,
      firstName: data.firstName,
      lastName: data.lastName,
    };
    signup(data)
      .then((response) =>
        response.json().then((res) => {
          const { id } = res;
          if (!id) {
            throw new Error(res.detail || '');
          }
          // handleStep(false);
          success(i18n._(t`Đăng ký tài khoản cá nhân thành công`));
          handleTempRegisterKey(res?.tempRegisterKey);
          history.push('/sign-up-success');
          // history.push('/sign-up-success');
        }),
      )
      .catch((err) => {
        error(
          (err && (err.detail || err.message)) ||
          'Oops! Something went wrong. Please try again!',
        );
      });
  };

  const handleShowPass = (key, value) => {
    if (key === 'auth') {
      setShowPass({ ...showPass, authPass: value });
    } else {
      setShowPass({ ...showPass, pass: value });
    }
  };

  return (
    <div
      className={`${step === 1 ? 'min-h-full' : 'h-0'
        } transition-all duration-300 w-full z-0 p-[70px] text-black`}
    >
      <div>
        <h1
          className={'text-luat_HN_primary font-bold text-[26px] sm:text-4xl'}
        >
          <Trans>Đăng ký tài khoản</Trans>
        </h1>
        <div
          className={`bg-luat_HN_primary h-[5px] rounded mt-[20px] mb-[50px] w-20`}
        />
      </div>
      <form className={'flex flex-col'} onSubmit={handleSubmit(onSubmit)}>
        <div className="text-[14px] ">
          <h1 className={'font-bold text-[22px] sm:text-2xl'}>
            <Trans>Thông tin cá nhân</Trans>
          </h1>
          <div className={`sm:flex`}>
            <div className={' py-1 lg:py-5 w-full sm:w-1/2 sm:mr-5'}>
              <div className={`mb-2 font-semibold `}>
                <span className={`text-red-500`}>*</span> <Trans>Họ</Trans>
              </div>
              <input
                className={`w-full py-2 px-5 rounded-md focus:ring outline-none border-2 ${errors.lastName ? 'border-red-500' : 'border-gray-300'
                  }`}
                placeholder={t`Nhập họ`}
                {...register('lastName')}
              />
              <div
                className={
                  'text-left text-red-500 font-bold mr-2 mt-1 h-6 text-xs'
                }
              >
                {errors.lastName?.message ? (
                  i18n._(t`${errors.lastName.message}`)
                ) : (
                  <>&nbsp;</>
                )}
              </div>
            </div>
            <div className={' py-1 lg:py-5 w-full sm:w-1/2 sm:ml-5'}>
              <div className={`mb-2 font-semibold`}>
                <span className={`text-red-500`}>*</span> <Trans>Tên</Trans>
              </div>
              <input
                className={`w-full py-2 px-5 rounded-md focus:ring outline-none border-2 ${errors.firstName ? 'border-red-500' : 'border-gray-300'
                  }`}
                placeholder={t`Nhập tên`}
                {...register('firstName')}
              />
              <div
                className={
                  'text-left text-red-500 font-bold mr-2 mt-1 h-6 text-xs'
                }
              >
                {errors.firstName?.message ? (
                  i18n._(t`${errors.firstName.message}`)
                ) : (
                  <>&nbsp;</>
                )}
              </div>
            </div>
          </div>

          <div className={`sm:flex`}>
            <div className={' py-1 lg:py-5 w-full sm:w-1/2 sm:mr-5'}>
              <div className={`mb-2 font-semibold`}>
                <span className={`text-red-500`}>*</span>{' '}
                <Trans>Số điện thoại</Trans>
              </div>
              <input
                className={`w-full py-2 px-5 rounded-md focus:ring outline-none border-2 ${errors.phone ? 'border-red-500' : 'border-gray-300'
                  }`}
                placeholder={t`Nhập số điện thoại`}
                {...register('phone')}
              />
              <div
                className={
                  'text-left text-red-500 font-bold mr-2 mt-1 h-6 text-xs'
                }
              >
                {errors.phone?.message ? (
                  i18n._(t`${errors.phone.message}`)
                ) : (
                  <>&nbsp;</>
                )}
              </div>
            </div>
            <div className={' py-1 lg:py-5 w-full sm:w-1/2 sm:ml-5'}>
              <div className={`mb-2 font-semibold`}>
                <span className={`text-red-500`}>*</span> <Trans>Email</Trans>
              </div>
              <input
                className={`w-full py-2 px-5 rounded-md focus:ring outline-none border-2 ${errors.email ? 'border-red-500' : 'border-gray-300'
                  }`}
                placeholder={t`Nhập email`}
                {...register('email')}
              />
              <div
                className={
                  'text-left text-red-500 font-bold mr-2 mt-1 h-6 text-xs'
                }
              >
                {errors.email?.message ? (
                  i18n._(t`${errors.email.message}`)
                ) : (
                  <>&nbsp;</>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className={`text-[14px] mt-5 sm:mt-10`}>
          <h1 className={'font-bold text-[22px] sm:text-2xl'}>
            <Trans>Thông tin tài khoản</Trans>
          </h1>
          <div className={' py-1 lg:py-5'}>
            <div className={`mb-2 font-semibold`}>
              <span className={`text-red-500`}>*</span>{' '}
              <Trans>Tên đăng nhập</Trans>
            </div>
            <input
              className={`w-full py-2 px-5 rounded-md focus:ring outline-none border-2 ${errors.login ? 'border-red-500' : 'border-gray-300'
                }`}
              placeholder={t`Nhập tên đăng nhập`}
              {...register('login')}
            />
            <div
              className={
                'text-left text-red-500 font-bold mr-2 mt-1 h-6 text-xs'
              }
            >
              {errors.login?.message ? (
                i18n._(t`${errors.login.message}`)
              ) : (
                <>&nbsp;</>
              )}
            </div>
          </div>

          <div className={`sm:flex`}>
            <div className={' py-1 lg:py-5 w-full sm:w-1/2 sm:mr-5'}>
              <div className={`mb-2 font-semibold`}>
                <span className={`text-red-500`}>*</span>{' '}
                <Trans>Mật khẩu</Trans>
              </div>
              <div className="relative w-full">
                <input
                  type={showPass.pass ? 'text' : 'password'}
                  onPaste={(e) => e.preventDefault()}
                  className={`w-full py-2 pl-5 pr-10 rounded-md focus:ring outline-none border-2 ${errors.password ? 'border-red-500' : 'border-gray-300'
                    }`}
                  placeholder={t`Nhập mật khẩu`}
                  {...register('password')}
                />
                <div
                  onClick={() => handleShowPass('pass', !showPass.pass)}
                  className="absolute top-3 right-3"
                >
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    className={`w-6 h-6 ${showPass.pass && 'hidden'}`}
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="10.5" cy="10.5" r="3" stroke="#9EA3A9" />
                    <path
                      d="M17.5567 9.43786C17.9475 9.90312 18.1429 10.1357 18.1429 10.5C18.1429 10.8643 17.9475 11.0969 17.5567 11.5621C16.2682 13.0962 13.5922 15.75 10.5 15.75C7.40777 15.75 4.73181 13.0962 3.44331 11.5621C3.05251 11.0969 2.85711 10.8643 2.85711 10.5C2.85711 10.1357 3.05251 9.90312 3.4433 9.43786C4.73181 7.90384 7.40777 5.25 10.5 5.25C13.5922 5.25 16.2682 7.90384 17.5567 9.43786Z"
                      stroke="#9EA3A9"
                    />
                  </svg>
                  <svg
                    width="21"
                    height="21"
                    className={`w-6 h-6 ${!showPass.pass && 'hidden'}`}
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M13.9684 10.972C13.9893 10.8177 14 10.6601 14 10.5C14 8.567 12.433 7 10.5 7C10.3399 7 10.1823 7.01075 10.028 7.03156L11.0592 8.06277C11.9909 8.27566 12.7243 9.0091 12.9372 9.94083L13.9684 10.972ZM8.22211 9.46835C8.07944 9.78287 8 10.1322 8 10.5C8 11.8807 9.11929 13 10.5 13C10.8678 13 11.2171 12.9206 11.5316 12.7779L12.2724 13.5187C11.7526 13.8246 11.1468 14 10.5 14C8.567 14 7 12.433 7 10.5C7 9.85322 7.17544 9.24741 7.48133 8.72757L8.22211 9.46835Z"
                      fill="#9EA3A9"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.0114 15.2574L13.2724 14.5184C12.4012 14.9645 11.4654 15.25 10.5003 15.25C9.09642 15.25 7.75468 14.6459 6.58311 13.8223C5.4149 13.0011 4.45533 11.9892 3.82647 11.2406C3.40001 10.7328 3.35742 10.6464 3.35742 10.5C3.35742 10.3536 3.40001 10.2672 3.82647 9.75945C4.38654 9.09266 5.20894 8.21713 6.20742 7.45344L5.49455 6.74057C4.46559 7.54414 3.62865 8.44017 3.06075 9.11628L3.00246 9.18546L3.00246 9.18546C2.66849 9.58123 2.35742 9.94985 2.35742 10.5C2.35742 11.0502 2.66849 11.4188 3.00246 11.8145L3.06075 11.8837C3.72041 12.6691 4.74307 13.7512 6.00802 14.6404C7.26961 15.5272 8.81197 16.25 10.5003 16.25C11.7728 16.25 12.9624 15.8394 14.0114 15.2574ZM8.18455 5.18793C8.91288 4.91658 9.68977 4.75 10.5003 4.75C12.1886 4.75 13.731 5.47277 14.9926 6.35963C16.2576 7.24884 17.2802 8.33093 17.9399 9.11628L17.9982 9.18546C18.3321 9.58122 18.6432 9.94985 18.6432 10.5C18.6432 11.0502 18.3321 11.4188 17.9982 11.8145L17.9399 11.8837C17.5574 12.339 17.053 12.8941 16.4501 13.4534L15.7424 12.7458C16.3179 12.2146 16.8035 11.6818 17.1741 11.2406C17.6006 10.7328 17.6432 10.6464 17.6432 10.5C17.6432 10.3536 17.6006 10.2672 17.1741 9.75945C16.5453 9.01077 15.5857 7.99892 14.4175 7.17772C13.2459 6.35414 11.9042 5.75 10.5003 5.75C9.98148 5.75 9.47114 5.83251 8.97474 5.97812L8.18455 5.18793Z"
                      fill="#9EA3A9"
                    />
                    <path d="M4.375 1.75L18.375 15.75" stroke="#9EA3A9" />
                  </svg>
                </div>
              </div>
              <div
                className={
                  'text-left text-red-500 font-bold mr-2 mt-1 h-6 text-xs'
                }
              >
                {errors.password?.message ? (
                  i18n._(t`${errors.password.message}`)
                ) : (
                  <>&nbsp;</>
                )}
              </div>
            </div>
            <div className={' py-1 lg:py-5 w-full sm:w-1/2 sm:ml-5'}>
              <div className={`mb-2 font-semibold`}>
                <span className={`text-red-500`}>*</span>{' '}
                <Trans>Xác nhận mật khẩu</Trans>
              </div>
              <div className="relative w-full">
                <input
                  type={showPass.authPass ? 'text' : 'password'}
                  onPaste={(e) => e.preventDefault()}
                  className={`w-full py-2 pl-5 pr-10 rounded-md focus:ring outline-none border-2 ${errors.authPassword ? 'border-red-500' : 'border-gray-300'
                    }`}
                  placeholder={t`Vui lòng nhập chính xác mật khẩu trước đó`}
                  {...register('authPassword')}
                />
                <div
                  onClick={() => handleShowPass('auth', !showPass.authPass)}
                  className="absolute top-3 right-3"
                >
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    className={`w-6 h-6 ${showPass.authPass && 'hidden'}`}
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="10.5" cy="10.5" r="3" stroke="#9EA3A9" />
                    <path
                      d="M17.5567 9.43786C17.9475 9.90312 18.1429 10.1357 18.1429 10.5C18.1429 10.8643 17.9475 11.0969 17.5567 11.5621C16.2682 13.0962 13.5922 15.75 10.5 15.75C7.40777 15.75 4.73181 13.0962 3.44331 11.5621C3.05251 11.0969 2.85711 10.8643 2.85711 10.5C2.85711 10.1357 3.05251 9.90312 3.4433 9.43786C4.73181 7.90384 7.40777 5.25 10.5 5.25C13.5922 5.25 16.2682 7.90384 17.5567 9.43786Z"
                      stroke="#9EA3A9"
                    />
                  </svg>
                  <svg
                    width="21"
                    height="21"
                    className={`w-6 h-6 ${!showPass.authPass && 'hidden'}`}
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M13.9684 10.972C13.9893 10.8177 14 10.6601 14 10.5C14 8.567 12.433 7 10.5 7C10.3399 7 10.1823 7.01075 10.028 7.03156L11.0592 8.06277C11.9909 8.27566 12.7243 9.0091 12.9372 9.94083L13.9684 10.972ZM8.22211 9.46835C8.07944 9.78287 8 10.1322 8 10.5C8 11.8807 9.11929 13 10.5 13C10.8678 13 11.2171 12.9206 11.5316 12.7779L12.2724 13.5187C11.7526 13.8246 11.1468 14 10.5 14C8.567 14 7 12.433 7 10.5C7 9.85322 7.17544 9.24741 7.48133 8.72757L8.22211 9.46835Z"
                      fill="#9EA3A9"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.0114 15.2574L13.2724 14.5184C12.4012 14.9645 11.4654 15.25 10.5003 15.25C9.09642 15.25 7.75468 14.6459 6.58311 13.8223C5.4149 13.0011 4.45533 11.9892 3.82647 11.2406C3.40001 10.7328 3.35742 10.6464 3.35742 10.5C3.35742 10.3536 3.40001 10.2672 3.82647 9.75945C4.38654 9.09266 5.20894 8.21713 6.20742 7.45344L5.49455 6.74057C4.46559 7.54414 3.62865 8.44017 3.06075 9.11628L3.00246 9.18546L3.00246 9.18546C2.66849 9.58123 2.35742 9.94985 2.35742 10.5C2.35742 11.0502 2.66849 11.4188 3.00246 11.8145L3.06075 11.8837C3.72041 12.6691 4.74307 13.7512 6.00802 14.6404C7.26961 15.5272 8.81197 16.25 10.5003 16.25C11.7728 16.25 12.9624 15.8394 14.0114 15.2574ZM8.18455 5.18793C8.91288 4.91658 9.68977 4.75 10.5003 4.75C12.1886 4.75 13.731 5.47277 14.9926 6.35963C16.2576 7.24884 17.2802 8.33093 17.9399 9.11628L17.9982 9.18546C18.3321 9.58122 18.6432 9.94985 18.6432 10.5C18.6432 11.0502 18.3321 11.4188 17.9982 11.8145L17.9399 11.8837C17.5574 12.339 17.053 12.8941 16.4501 13.4534L15.7424 12.7458C16.3179 12.2146 16.8035 11.6818 17.1741 11.2406C17.6006 10.7328 17.6432 10.6464 17.6432 10.5C17.6432 10.3536 17.6006 10.2672 17.1741 9.75945C16.5453 9.01077 15.5857 7.99892 14.4175 7.17772C13.2459 6.35414 11.9042 5.75 10.5003 5.75C9.98148 5.75 9.47114 5.83251 8.97474 5.97812L8.18455 5.18793Z"
                      fill="#9EA3A9"
                    />
                    <path d="M4.375 1.75L18.375 15.75" stroke="#9EA3A9" />
                  </svg>
                </div>
              </div>
              <div
                className={
                  'text-left text-red-500 font-bold mr-2 mt-1 h-6 text-xs'
                }
              >
                {errors.authPassword?.message ? (
                  i18n._(t`${errors.authPassword.message}`)
                ) : (
                  <>&nbsp;</>
                )}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className={`flex items-center`}>
            <label className="checkbox-container">
              <input type="checkbox" {...register('terms')} />
              <span className="checkmark"></span>
            </label>
            <div className={`text-black`}>
              <Trans>Tôi đồng ý với các</Trans>{' '}
              <a
                className={`text-luat_HN_primary hover:text-luat_HN_primary hover:underline`}
                href={renderUrlTTerms()}
                rel='noreferrer'
                target="_blank"
              >
                <Trans>điều khoản và điều kiện</Trans>
              </a>{' '}
              <Trans>của ĐOÀN LUẬT SƯ TP. HÀ NỘI</Trans>
            </div>
          </div>
          <div className={'text-red-500 font-bold mr-2 mt-1 h-[30px] text-xs'}>
            {errors.terms?.message ? (
              i18n._(t`${errors.terms.message}`)
            ) : (
              <>&nbsp;</>
            )}
          </div>
        </div>

        <div className={'mx-auto'}>
          <div className={`flex justify-center my-[40px]`}>
            <button
              className={
                ' w-[140px] h-[50px] rounded-[6px] group relative overflow-hidden'
              }
              type="submit"
            >
              <div
                className={`text-white w-full rounded-[6px] bg-opacity-10 z-20 relative transition duration-300
                  flex items-center justify-center group-hover:text-luat_HN_primary border-2 border-luat_HN_primary h-full bg-luat_HN_primary`}
              >
                <Trans>Đăng ký</Trans>
              </div>
              <div
                className={`text-white w-full rounded-[6px] bg-luat_HN_primary z-0 h-full
                  absolute bottom-0 right-0 group-hover:w-0 transition-all duration-300`}
              ></div>
            </button>
          </div>
          {/* <div
            className={`mx-10 md:flex items-center justify-evenly text-center`}
          >
            <div>
              <Trans>Hoặc đăng nhập tài khoản bằng</Trans>
            </div>
            <a
              className="block"
              href={GOOGLE_AUTH_URL + '?redirect=' + getRedirect()}
            >
              <img
                className={'w-10 inline-block'}
                src={googleLogo}
                alt="Google"
              />
            </a>
          </div> */}
          <div className={`md:my-5 mx-auto text-center md:flex`}>
            <div>
              <Trans>Bạn đã có tài khoản ?</Trans>
            </div>
            <Link
              to={`/login`}
              className={`text-luat_HN_primary hover:underline cursor-pointer md:mt-0 mt-2 ml-0 md:ml-2 underline underline-offset-4 `}
            >
              <Trans>Nhấn vào đây để đăng nhập</Trans>
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
};

export default FormUserSignUp;
